import type { FaireProductEntity } from "../../entity_types/product";

export const p_n655ndbqj2: FaireProductEntity = {
  token: "p_n655ndbqj2",
  type: "product",
  name: "Bees Swedish Cloth Set",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/51c02812f34cbb23576c23b4965d9c7ae72e4f9cac53b8d587b9a36bb410b170.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5e690ab38a620d877f7907f0d6a02129e4e9b56650770bbea78123378e419f12.jpeg",
    "https://cdn.faire.com/fastly/baf70a5357f85576aa94e40accfec9ac8dcc778ce27e17fb5c93849ec2226427.jpeg",
    "https://cdn.faire.com/fastly/ae2490dffb6672477cc36aa8709384af8479f2ac6fd09d1c829877cfdd166015.jpeg",
    "https://cdn.faire.com/fastly/8386d68544544a812a10daf4091c5e3835e14fdd9ea320c6bb03b041d922bca5.jpeg"
  ],
  priceDollars: 5.5,
  description: "Safe to use on all types of surfaces, eco-friendly Swedish Dishcloths dry quickly and are antibacterial for more hygienic cleaning with reduced waste. This set of 2 Swedish Dishcloths from our Garden Collection features bee inspired designs on each cloth. Bee designs are replicated from original art hand painted in a watercolor style. Our Bees Swedish dishcloth set is ultra-absorbent and conveniently machine washable for easy cleaning and reuse. Dishcloths are attached to a header card with a hole for easy store rack display. A stylish bee-themed set of reusable dishcloths perfect for replacing dull sponges and paper towels with long-lasting colorful designs.",
  tags: [],
  msrpDollars: 10.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:21.562Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
